module.exports = __webpack_public_path__ + "assets/img/phone2.5560c0d4.png";